<template>
  <div class="orderEntry">
    <h2 class="info_title">{{info._title}}</h2>
    <!-- 状态描述 -->
    <el-descriptions class="main" title="主体信息" :column="3"  border>
      <template slot="extra">
        <el-button type="primary" size="small" @click="startBaojia">{{buttonTilte}}</el-button>
      </template>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          采购员
        </template>
        {{info.fb_user_name}}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-flag"></i>
          当前报价人数
        </template>
        {{info._count}}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-view"></i>
          浏览量
        </template>
        {{info.hits}}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-tickets"></i>
          是否开始报价
        </template>
        {{info._sts}}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-caret-right"></i>
          进行状态
        </template>
        {{info._type}}
      </el-descriptions-item>

       <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          交货期
        </template>
        <el-tag size="small" type="danger">{{info.jhrq}}</el-tag>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          发布时间
        </template>
        {{info.create_time}}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          开始时间
        </template>
        {{info.start_time}}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          结束时间
        </template>
        {{info.finsh_time}}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-date"></i>
          付款账期
        </template>
        {{info.fkzq}}
      </el-descriptions-item>

      <el-descriptions-item :span="2">
        <template slot="label" >
          <i class="el-icon-date"></i>
          付款方式
        </template>
        {{info._fkfs}}
      </el-descriptions-item>

      <el-descriptions-item v-if="isLogin">
        <template slot="label">
          <i class="el-icon-user"></i>
          联系人
        </template>
        {{info.contacts}}
      </el-descriptions-item>

      <el-descriptions-item :span="2" v-if="isLogin">
        <template slot="label" >
          <i class="el-icon-phone"></i>
          联系方式
        </template>
        {{info.contact}}
      </el-descriptions-item>

      <el-descriptions-item :span="3">
        <template slot="label" >
          <i class="el-icon-s-comment"></i>
          备注
        </template>
        {{info.marks}}
      </el-descriptions-item>
      <el-descriptions-item :span="3">
        <template slot="label">
          <i class="el-icon-files"></i>
          附件(登录查看)
        </template>
        <el-button
         class="fujian"
         size="small" 
         type="primary" 
         icon="el-icon-download" 
         v-for="(item,index) in info.files" 
         :key="index"
         @click="downloadFiels(item.url)">
         {{item.name}}
         </el-button>
      </el-descriptions-item>
    </el-descriptions>
    <template>
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%">

        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label=" 要求：">
                <span>{{ props.row.demand }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column
          prop="sqt"
          label="序号"
          width="65">
        </el-table-column>
        <el-table-column
          prop="title"
          label="材料名称">
        </el-table-column>
        <el-table-column
          prop="caizhi"
          label="执行标准/材质">
        </el-table-column>
        <el-table-column
          prop="guige"
          label="规格">
        </el-table-column>
        <el-table-column
          prop="num"
          label="数量"
          width="80">
        </el-table-column>
        <el-table-column
          prop="unit"
          label="单位"
          width="65">
        </el-table-column>
      </el-table>
    </template>

    <!-- 中标公告 -->
    <div v-if="isNaN(info._win)">
      <br/><br/>
      <div class="el-descriptions__title">中标公告</div>
      <template>
        <el-table
          :data="info._win"
          border
          style="width: 100%">
          <el-table-column
            prop="company"
            label="公司名称">
          </el-table-column>
          <el-table-column
            prop="money"
            label="金额公告（元）">
          </el-table-column>
          <el-table-column
            prop="content"
            label="原因公告">
          </el-table-column>
        </el-table>
      </template>
    </div>

    <!-- 用户报价操作部分 -->
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :with-header="false"
      size="85%"
      >
      <div class="bj_container">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-row :gutter="20">
                  <el-col :span="6">
                      <el-form-item label="支付方式" prop="pay_type">
                        <el-input v-model="form.pay_type" placeholder="电汇/承兑"></el-input>
                      </el-form-item>
                  </el-col>

                   <el-col :span="6">
                      <el-form-item label="账期" prop="zq">
                        <el-input v-model="form.zq" placeholder="账期"></el-input>
                      </el-form-item>
                   </el-col>

                   <el-col :span="6">
                      <el-form-item label="交货日期" prop="jhrq">
                        <el-input v-model="form.jhrq" placeholder="请填写您的大致交货日期"></el-input>
                      </el-form-item>
                   </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="6">
                      <el-form-item label="发票方式" prop="fp">
                        <el-select v-model="form.fp" placeholder="请选择您需要的发票方式">
                          <el-option 
                            v-for="(item,index) in fpOptions" 
                            :key="index" 
                            :label="item.label" 
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="税点" prop="sd">
                        <el-input v-model="form.sd" placeholder="税点"></el-input>
                      </el-form-item>
                    </el-col>
                </el-row>
                
                <el-link :underline="false" v-if="!SeeLog"> 
                  报价的操作方式有两种，<b style="color:red;">选择其中一种即可</b>。
                  <br/>
                  方式一：直接填写下方报价清单价格。（当报价清单项比较少时，建议使用）
                </el-link><br/>

                <!-- 表格详细数据 -->
                <template>
                  <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="sqt"
                      label="序号"
                      width="65">
                    </el-table-column>
                    <el-table-column
                      prop="title"
                      label="材料名称">
                    </el-table-column>
                    <el-table-column
                      prop="caizhi"
                      label="执行标准/材质">
                    </el-table-column>
                    <el-table-column
                      prop="guige"
                      label="规格">
                    </el-table-column>
                    <el-table-column
                      prop="num"
                      label="数量"
                      width="70">
                    </el-table-column>
                    <el-table-column
                      prop="unit"
                      label="单位"
                      width="65">
                    </el-table-column>
                    <el-table-column
                      prop="demand"
                      label="要求">
                    </el-table-column>

                    <el-table-column label="操作" width="500px">
                      <template slot-scope="scope">
                        <el-row>
                          <el-col :span="12">
                            <el-input 
                              v-model="tableData[scope.$index].price" 
                              type="number" 
                              :disabled="SeeLog?true:false" 
                              step="0.01" 
                              @input="changeNum(scope.$index,'price')">
                              <template slot="prepend">电汇单价</template>
                            </el-input>
                          </el-col>
                          <el-col :span="12">
                            <el-input 
                              v-model="tableData[scope.$index].price_all" 
                              type="number" 
                              :disabled="true" 
                              step="0.01">
                              <template slot="prepend">电汇总价</template>
                            </el-input>
                          </el-col>

                          <el-col :span="12">
                            <el-input 
                              v-model="tableData[scope.$index].cd_price" 
                              type="number" 
                              :disabled="SeeLog?true:false" 
                              step="0.01" 
                              @input="changeNum(scope.$index,'cd_price')">
                              <template slot="prepend">承兑单价</template>
                            </el-input>
                          </el-col>

                          <el-col :span="12">
                            <el-input 
                              v-model="tableData[scope.$index].cd_price_all" 
                              type="number" 
                              :disabled="true" 
                              step="0.01" >
                              <template slot="prepend">承兑总价</template>
                            </el-input>
                          </el-col>

                          <el-col :span="12">
                            <el-input v-model="tableData[scope.$index].brand" :disabled="SeeLog?true:false"><template slot="prepend">品牌</template></el-input>
                          </el-col>

                          <el-col :span="12">
                            <el-input v-model="tableData[scope.$index].jh_time" :disabled="SeeLog?true:false"><template slot="prepend">交货期</template></el-input>
                          </el-col>

                          <el-col :span="12">
                            <el-input v-model="tableData[scope.$index].jlfs" :disabled="SeeLog?true:false"><template slot="prepend">计量方式</template></el-input>
                          </el-col>

                          <el-col :span="12">
                            <el-input v-model="tableData[scope.$index].marks" :disabled="SeeLog?true:false"><template slot="prepend">备注</template></el-input>
                          </el-col>
                       </el-row>
                      </template>
                    </el-table-column>
                    
                  </el-table>
                </template>
                <div class="clear"></div><br/>

                <el-link :underline="false" v-if="!SeeLog"> 
                  方式二：下载下方报价模板填写完毕后上传。（ 当报价清单较多比较繁琐时 ）
                </el-link><br/>
                <el-button size="mini" type="primary" @click="downloadTemplate" v-if="!SeeLog">第一步：下载上传模板<i class="el-icon-download el-icon--right"></i></el-button>
                <el-upload
                        class="excel-upload"
                        :action="uploadUrl"
                        list-type="picture"
                        :show-file-list="false"
                        name="UploadForm[excelFile]"
                        :on-success="uploadFinsh" v-if="!SeeLog">
                    <el-button size="mini" type="primary">第二步：上传第一步填写好的表格<i class="el-icon-upload el-icon--right"></i></el-button>
                </el-upload><br/><br/>

                <el-link :underline="false" v-if="!SeeLog"> 
                  若您需要针对上诉报价进行补充，请上传您的附件。（ <b style="color:red;">非必填</b> ）
                </el-link><br/>
                <el-form-item label="附件上传">
                  <el-upload
                    list-type="picture-card"
                    :action="config.domain"
                    :http-request = "supplierUpload"
                    :file-list = "fileList"
                    :auto-upload="true">
                      <i slot="default" class="el-icon-plus"></i>
                      <div 
                        slot="file"
                        slot-scope="{file}">
                        <img
                          class="el-upload-list__item-thumbnail"
                          :src="file.url"
                        >
                        <span class="el-upload-list__item-actions">
                          <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="handleRemove(file)">
                            <i class="el-icon-delete"></i>
                          </span>
                          <span
                            class="el-upload-list__item-delete"
                            @click="handleDownload(file.url)">
                            <i class="el-icon-download"></i>
                          </span>
                        </span>
                      </div>
                  </el-upload>
                </el-form-item>

                <el-form-item v-if="!SeeLog">
                  <el-button type="primary" @click="onSubmit('form')" v-loading.fullscreen.lock="fullscreenLoading" >提交报价</el-button>
                </el-form-item>
              </el-form>

              <el-link :underline="false" v-if="!SeeLog"> 
                  注意：<br/>
                  <p style="color:red;">1.报价时，请识别单价与总价的区别，如果您在单价栏位直接填入总价，我们会因为报价过高，您的报价将不会中标。  （ 总价 = 单价 * 数量 ）<br/></p>
                  2.报价操作有疑问或者操作失败的，请加平台管理员微信kurtcheny提供技术支持（ 加好友时请备注为 "供应商报价协助" ）。<br/>
              </el-link><br/>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import * as qiniu from "qiniu-js"
import { OrderEntry,CheckOrderStatus,QiniuToken,GetOrderEntryExcel,OfferOrder,Config } from '../../api';
import { baseUrl,backendUrl } from '@/config/env'
export default{
  data(){
    return {
      code:'',
      id:'',
      SeeLog:false,
      isLogin:false,
      //基本信息
      info:[],
      buttonTilte:'立即报价',
      tableData:[],
      //弹窗部分
      drawer:false,  //true   false
      direction:'rtl',
      fullscreenLoading:false,
      //具体的报价表格部分
      form:{},
      rules:{
        pay_type: [
            { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        jhrq: [
            { required: true, message: '请输入交货日期', trigger: 'blur' },
        ],
        fp: [
            { required: true, message: '请选择发票方式', trigger: 'blur' },
        ],
        zq: [
            { required: true, message: '账期必填', trigger: 'blur' },
        ],
        sd: [
            { required: true, message: '税点必填', trigger: 'blur' },
        ]
      },
      fpOptions:[], //发票枚举
      //文件上传组件
      fileList:[],
      config:{
        token:'',
        region:'qiniu.region.z0',  //z0华东区域 z1华北区域  z2代表华南区域  na0北美区域   as0新加坡区域
        domain:'https://upload.qiniup.com',  //上传地址
      },
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,

      //excel文件上传的解析
      uploadUrl:baseUrl+'/v1/file/importexcel?type=offer-orderentry-parse'
    }
  },
  mounted(){
    var that = this;
    let code = this.$route.query.code;
    let id = this.$route.query.id;
    //针对报价编码进行的检测
    if (code) {
      this.id = id;
      this.code = code;
      this.getOrderDetail(code,id)

    } else {
      this.$message.error({
        type:'error',
        message:'非法访问，跳转到首页',
        onClose(){
          that.$router.push({path:'/orderList'});
        }
      });

    }
    
    //部署登录状态
    this.isLogin = window.localStorage.getItem('hasLogin');
    this.getQiniuTOken();
    this.getConfig();

    //禁止IE
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      alert("IE浏览器不兼容，请使用360/搜狗/谷歌浏览器/Microsoft Edge等浏览器进行操作");
    }

  },
  methods:{
    getConfig(){ //获取一些默认的配置
      var that = this;
      Config({configType:'fpType'}).then(res=>{
          that.fpOptions = res.data
      })
    },
    getOrderDetail(code,id){ //获取报价详细信息
      var that = this;
      var postData = {
          code:code,
          id:id
      };
      OrderEntry(postData).then(res=>{
        if (res.code == 200) {
          that.info = res.data;
          that.tableData = res.data._entry;
          if (res.data.inter) {
            that.form.pay_type = res.data.inter.pay_type;
            that.form.jhrq = res.data.inter.jhrq;
            that.form.fp = parseInt(res.data.inter.fp);
            that.form.zq = res.data.inter.zq;
            that.form.sd = res.data.inter.sd;
            that.fileList = JSON.parse(res.data.inter.files);
            that.SeeLog = true;
            that.buttonTilte = "我的报价";

          }
          document.title = "博瑞特采购平台"+res.data._title + "采购报价"; //设置标题

        } else {
          that.$message.error(res.message);

        }

      })
    },
    downloadFiels(url){ //下载文件
      window.open(url);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) { //备注数据过多，进行优化
      row,column
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    startBaojia(){ //开始报价
      var that = this;
      if (!this.isLogin) {
        this.$message.error("请注册登录后再进行报价");
        return false;
      }
      //进行报价检测
      var postData = {code:this.code};
      if (this.id) postData.id = this.id;
      CheckOrderStatus(postData).then(res=>{
        if (res.code == 400) {
          that.$message.error(res.message);
          return false;
        } else {
          that.Bjstart();
        }
      })
    },
    Bjstart(){ //开始报价动作
      this.drawer = true;
    },
    supplierUpload(request){ //文件上传部分重写
      if (this.SeeLog) {
        this.$message.error("查看历史记录无需上传");
        return false;
      }
      let token = this.config.token;

      let d = new Date();
      let filePath = d.getFullYear() + '' +d.getMonth();
      let key = 'app-offer/' + filePath + '/' + request.file.uid + request.file.name; //上传的空间地址

      const putExtra = {
        mimeType: null, // mimeType: null || array，用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
      };
      let observable = qiniu.upload(request.file,key,token,putExtra);

      var subscription = observable.subscribe(
        (next)=>{
          if (next.total.percent == 100) { //上传成功
            this.$message.success("上传成功");
            this.fileList.push({
              name:request.file.name,
              status:'success',
              uid:request.file.uid,
              url:this.config.url + '/' + key
            })
          }
        }, 
        (error)=>{
          if (error.code == 401) {
            this.$message.error("页面停滞超过30分钟，请刷新当前页面重新操作。");
          }
          // request.onError(error);
        }, 
        (complete)=>{
          console.log(complete)
        }
      ); //上传进度的一些实时反馈信息，搞进度条可以，我这里直接放弃掉
      // console.log(subscription)
      return subscription;
    },
    handleRemove(file) { //删除文件
      var uid = file.uid;
      var that = this;
      this.fileList.map((item,index)=>{
        if(item.uid == uid) {
          that.fileList.splice(index,1);
        }
      })
    },
    handleDownload(file){ //下载文件
      window.open(file);
    },
    getQiniuTOken(){ //七牛云的token后端获取,一个token能用一个小时
      QiniuToken().then(res=>{
        if (res.code == 200) {
          this.config.token = res.data.token;
          this.config.url = res.data.url;
        } else {
          this.$mssage.error(res.message);
        }
      })
    },
    onSubmit(formName){ //提交数据
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.files = this.fileList;
          //价格检测
          var checkPrice = true;
          this.tableData.map((item)=>{
            if (item.price < 0 && item.cd_price < 0) {
              checkPrice = false;
            }
          })

          if (!checkPrice){
              this.$message.error("材料价或承兑价不可小于0，请修改后再提交");
              return false;
          }

          //提交报价清单
          var postData = {
            code:this.code,
            form:this.form,
            entry:this.tableData,
          };
          this.fullscreenLoading = true;

          OfferOrder(postData).then(res=>{
              if(res.code == 200) {
                that.$message({
                  type:'success',
                  message:"报价成功，若您入围或中标会短信提示。",
                  onClose(){
                    that.fullscreenLoading = false;
                    that.$router.push({path:'/log'});
                  }
                });
              
              } else if(res.code == 400) {
                that.fullscreenLoading = false;
                that.$message.error(res.message)
              }
          })
        }
      });
    },
    changeNum(index,field){ // 输入框输入的数字不能小于0
        var value = this.tableData[index][field];
        if (value < 0) {
          this.tableData[index][field] = Math.abs(value)
        }

        //改变总价的值
        this.tableData[index].price_all = Math.round((this.tableData[index].price * this.tableData[index].num)*100)/100;
        this.tableData[index].cd_price_all = Math.round((this.tableData[index].cd_price * this.tableData[index].num)*100)/100;
    },
    downloadTemplate(){ // 下载报价表单
      var that = this;
      GetOrderEntryExcel({code:this.code}).then(res=>{
        if(res.code == 200) {
          that.$message({
            type:'success',
            message:'提示：除填写字段外，请不要更改excle表中的任何数据',
            onClose(){
              window.open(backendUrl+res.data);
            }
          })
          
        } else {
          that.$message.error("下载失败，请手动填写报价");
        }
      })
    },
    uploadFinsh(response){ //解析完excel之后
        var that = this;
        if (response.code == 200) {
          for ( var excelIndex in response.data ) {
            this.tableData.map((item,index)=>{
              // console.log(response.data[excelIndex][1]);
              // console.log(item.material_id);
              if (response.data[excelIndex][1] == item.material_id && response.data[excelIndex][0] == item.sqt) {
                that.tableData[index].price = response.data[excelIndex][8];
                that.tableData[index].cd_price = response.data[excelIndex][9];
                that.tableData[index].brand = response.data[excelIndex][10];
                that.tableData[index].jh_time = response.data[excelIndex][11];
                that.tableData[index].jlfs = response.data[excelIndex][12];
                that.tableData[index].marks = response.data[excelIndex][13];
              }
            })
          }
        }
    },
  }
}
</script>

<style lang="less" scoped>
.demo-table-expand {
  font-size: 0;
}
.el-form-item>label{
  width: 120px;
  display: block;
  padding: 0px 50px!important;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  // width: 50%;
}
.orderEntry{
  .info_title{
    text-align: center;
  }
  .offer_top{
    margin-top: 50px;
  }
  .bj_container{
    width: 90%;
    margin: 50px auto;
  }
  .clear{
    clear: both;
  }
  .excel-upload{
    display: inline;
    margin-left: 15px;
    margin-right: 15px;
  }
  .fujian{
    margin-top: 5px;
  }
}
@media screen and(max-width:480px) {
  .main{display: none;}  
}
</style>